import React from 'react';

export interface AlertProps {
  tone?: 'info' | 'success' | 'warning' | 'danger';
  title?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
}

const tones = {
  info: { bg: 'var(--info-tint)', border: 'var(--border-accent)', fg: 'var(--accent)' },
  success: { bg: 'var(--success-tint)', border: 'rgba(47,217,122,0.35)', fg: 'var(--success)' },
  warning: { bg: 'var(--warning-tint)', border: 'rgba(245,185,66,0.35)', fg: 'var(--warning)' },
  danger: { bg: 'var(--danger-tint)', border: 'rgba(255,92,92,0.35)', fg: 'var(--danger)' },
};

export function Alert({ tone = 'info', title, children, icon, style }: AlertProps) {
  const t = tones[tone] || tones.info;
  return (
    <div
      style={{
        display: 'flex',
        gap: 12,
        alignItems: 'flex-start',
        padding: '14px 16px',
        background: t.bg,
        border: `1px solid ${t.border}`,
        borderRadius: 'var(--radius-md)',
        fontFamily: 'var(--font-body)',
        ...style,
      }}
    >
      {icon && <span style={{ color: t.fg, flexShrink: 0, marginTop: 1, display: 'inline-flex' }}>{icon}</span>}
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && (
          <div style={{ fontWeight: 'var(--fw-semibold)', color: t.fg, fontSize: 'var(--text-sm)', marginBottom: 2 }}>
            {title}
          </div>
        )}
        <div style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-sm)', lineHeight: 'var(--lh-normal)' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
